module.exports = __webpack_public_path__ + "img/Group 28074@2x.b521a92b.png";